module.exports = __webpack_public_path__ + "static/media/b-class@2x.879b591a.png";